// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
import Image from 'Common/Image';

// eslint-disable-next-line no-unused-vars
import { getObjectEntries } from 'Common/Polyfills';
import { connect } from 'react-redux';

/**
 * Picture React component.
 */
export class Picture extends PureComponent<*, *> {
  /**
   *  Props implementation.
   */
  static propTypes = {
    pictures: PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      title: PropTypes.string,
      alt: PropTypes.alt
    }),
    viewport: PropTypes.string,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    altImage: PropTypes.string
  };

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object): { viewport: Object } {
    return {
      viewport: state.viewport.viewport
    };
  }

  /**
   *  Default props.
   */
  static defaultProps: Object = {
    pictures: {
      image: {
        lg: `${process.env.PUBLIC_URL || ''}/images/fallback.png`
      },
      title: 'Image unavailable',
      alt: 'Image unavailable'
    }
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const { image, title, alt, href } = this.props.pictures;
    const { viewport, altImage } = this.props;
    let imageSize = viewport === 'xs' ? 'sm' : 'lg';
    if (image && image[imageSize]) {
      return <Image src={image[imageSize]} alt={alt} title={title} />;
    } else if (href) {
      return <Image src={href} alt={alt || title || altImage} title={title} />;
    }
    return null;
  }
}

// $FlowFixMe
export default connect(Picture.mapStateToProps, null)(Picture);



// WEBPACK FOOTER //
// ./src/Common/Picture/index.js